// Seans verisi enum → Türkçe etiket dönüşümleri.
// ESP32 MQTT protokolü: gender/skin_type/hair_type uint8, area zaten Türkçe string gönderir.
// Legacy area map: eski firmware İngilizce ("face" vb.) gönderirse geri uyumluluk sağlar.

const genderMap = { 0: 'Erkek', 1: 'Kadın' };

const skinTypeMap = { 0: 'Tip I', 1: 'Tip II', 2: 'Tip III', 3: 'Tip IV', 4: 'Tip V' };

const hairTypeMap = { 0: 'Çok İnce', 1: 'İnce', 2: 'Orta', 3: 'Kalın', 4: 'Çok Kalın' };

const legacyAreaEnToTr = {
  face: 'Yüz',
  arm: 'Kol',
  belly: 'Karın',
  armpit: 'Koltuk Altı',
  genital: 'Genital',
  upper_leg: 'Üst Bacak',
  lower_leg: 'Alt Bacak',
  back: 'Sırt',
  butt: 'Popo',
};

const toNumericKey = (value) => (typeof value === 'string' ? parseInt(value, 10) : value);

export const formatGender = (value) => {
  const key = toNumericKey(value);
  return genderMap[key] ?? '-';
};

export const formatSkinType = (value) => {
  const key = toNumericKey(value);
  return skinTypeMap[key] ?? '-';
};

export const formatHairType = (value) => {
  const key = toNumericKey(value);
  return hairTypeMap[key] ?? '-';
};

export const formatArea = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const lower = String(value).toLowerCase();
  return legacyAreaEnToTr[lower] || value;
};
